module.exports = __webpack_public_path__ + "img/logo.8d816a4f.png";